import React, { Fragment } from 'react';
import { Tooltip } from 'react-tippy';

const Lock = () => (
  <Fragment>
    <Tooltip
      title="Adquiere un plan para visualizar"
      position="bottom"
      trigger="mouseenter"
      followCursior
    >
      <i className="fa fa-lock" />
    </Tooltip>
  </Fragment>
);

export default Lock;



// WEBPACK FOOTER //
// ./src/components/Lock/index.js